import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import OTPComponent from './OTPComponent';
import { validateMobile, validateEmail } from '../../utils/inputValidator';
import OldPasswordComponent from './OldPasswordComponent';
import { signupSendOTP, signupAuthUser } from '../actions/signupAction';
import { setReferrerDetails } from '../../myaccount/actions/referAndEarn';
import { accountCheck, socialAuth } from '../actions/signinAction';
import { hideModal } from '../../actions/modal.js';
import { parseJwt } from '../../utils/loginUtil';
import cleverTapPushEvent from '../../modules/ajio-util/cleverTap/eventUtils';
import CLEVERTAP_EVENT_NAMES from '../../modules/ajio-util/cleverTap/eventConstants';
import { createRedirectUri } from '../../utils/redirectUtil';
import { createCookie } from '../../components/common/Cookie';
import { requestType } from '../../constants/constant.js';
import {
  getReferralFeatureEnableFlag,
  getRefereeEnableFlag,
  getReferralCongratulationHeading,
  getReferralCongratulationSubHeading
} from '../../Flags/selectors';
import { getUaas, getEnableRestorePhoneNumber } from '../../refresh/selectors/featureFlagsSelector';
import properties from '../../modules/ajio-util/properties';
import { gtmEventPush, gtmPagePush, segmentEventPush } from '../../modules/ga/GTMdatalayer';
import { signInCheck } from '../../components/common/CheckUserStatus';

import { getLuxeFlags } from '../../Flags/selectors';
import { getCurrentStore } from '../../refresh/selectors/metaData';
import screen from '../../utils/pageType';

class SignUpSocial extends React.Component {
  constructor(props) {
    super(props);
    this.handleSendOTPSubmit = this.handleSendOTPSubmit.bind(this);
    this.state = {
      errorMsg: '',
      mobNum: '',
      showSendOTP: false,
      showEnterOTP: false,
      recvdOTP: '',
      showTimer: true,
      existingUser: false,
      socialInfo: {},
      inviteCode: '',
      setInviteCodeError: true,
      inviteCodeError: '',
      userEmailID: ''
    };
  }

  componentDidMount() {
    gtmPagePush('One Last Step', 'user account screen', window.__ENV__ || '');
    localStorage.setItem('LoginModelType', 'One Last Step');
    let isGpay = sessionStorage.getItem('gpay') === 'true';
    if (isGpay) {
      microapps.getPhoneNumber().then(response => {
        const decodedResponse = parseJwt(response);
        const phoneNumber = decodedResponse.phone_number;
        const parserPhoneNumber = phoneNumber.slice(-10);
        this.setState({ mobNum: parserPhoneNumber });
      });
      const gPayConfig = sessionStorage.getItem('gpay_config');
      const decodedResponse = parseJwt(gPayConfig);
      sessionStorage.removeItem('gpay_config');
      var socialAuthObj = {
        firstName: decodedResponse.name,
        login: decodedResponse.email,
        password: '',
        token: gPayConfig,
        genderType: '',
        requestType: requestType.SENDOTP,
        loginvia: 'google'
      };
      this.setState({ socialInfo: socialAuthObj });
    }
    const { flags = {}, referrerDetails: { referralCode = '' } = {} } = this.props;
    if (getReferralFeatureEnableFlag(flags) && getRefereeEnableFlag(flags) && referralCode) {
      this.referralGtmEventPush('Entered referral code auto filled');
      this.setState({ inviteCode: referralCode });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.state.setInviteCodeError && this.props.errMsg && this.props.errMsg.includes('code')) {
      this.setState({ inviteCodeError: this.props.errMsg, setInviteCodeError: false });
    }
  }

  referralGtmEventPush = (label, category = 'bannerimpression') => {
    gtmEventPush({
      event: category,
      event_category: category,
      event_action: 'Signup - referral code',
      event_label: label
    });
  };

  renderReferralHeader = () => {
    if (
      getReferralFeatureEnableFlag(this.props.flags) &&
      getRefereeEnableFlag(this.props.flags) &&
      this.props.viewSiteAs !== 'desktop'
    ) {
      const { referrerDetails, refereeIncentive } = this.props;
      const { referralCode, referrerName } = referrerDetails;

      if (referralCode) {
        return null;
      }
    }
    return <h1> One last step </h1>;
  };

  updateReferralCode = () => {
    const { inviteCode = '' } = this.state;
    const { referrerDetails: { referralCode = '' } = {}, setReferrerDetailsObj } = this.props;
    this.setState({ inviteCodeError: '', setInviteCodeError: false });
    if (referralCode === '' && inviteCode === '') {
      return;
    }
    if (inviteCode !== referralCode) {
      this.referralGtmEventPush('Entered referral code manually', 'buttonTap');
      setReferrerDetailsObj({
        referralCode: inviteCode,
        referrerName: ''
      });
    }
  };

  renderInviteCodeInputError = msg => {
    this.referralGtmEventPush('Entered referral code failed', 'buttonTap');
    return (
      <div id="error-msg" className="error-msg" aria-live='polite'>
        {msg}
      </div>
    );
  };

  renderInviteCodeInput = () => {
    if (getReferralFeatureEnableFlag(this.props.flags) && getRefereeEnableFlag(this.props.flags)) {
      this.referralGtmEventPush('Enter referral code visible to customer');
      return (
        <>
          <div>
            <input
              type="text"
              name="inviteCode"
              className="login-form-inputs"
              placeholder="Invite code (optional)"
              size="9"
              maxLength="9"
              value={this.state.inviteCode}
              onChange={e => {
                this.setState({ inviteCode: e.target.value });
              }}
              onBlur={this.updateReferralCode}
            />
          </div>
          {this.state.inviteCodeError
            ? this.renderInviteCodeInputError(this.state.inviteCodeError)
            : null}
        </>
      );
    }
    return null;
  };

  setReferralSuccessData = () => {
    const {
      flags = {},
      referrerDetails: { referrerName = '' } = {},
      refereeIncentiveExpiresIn = {},
      refereeIncentive = 0
    } = this.props;
    const { inviteCode } = this.state;
    if (getReferralFeatureEnableFlag(flags) && getRefereeEnableFlag(flags) && inviteCode) {
      const { unit = '', value = 0 } = refereeIncentiveExpiresIn;
      if (window.sessionStorage) {
        const userName = referrerName || 'Your friend';
        const incentive = refereeIncentive.toFixed();
        let cashMessage = getReferralCongratulationHeading(flags).replace('_USERNAME_', userName);
        cashMessage = cashMessage.replace('_INCENTIVE_', incentive);
        let expiresInMessage = getReferralCongratulationSubHeading(flags).replace(
          '_DURATION_VALUE_',
          value
        );
        expiresInMessage = expiresInMessage.replace('_DURATION_UNIT_', unit);
        const stringifiedMessageObject = JSON.stringify({ cashMessage, expiresInMessage });
        const encodedMsg = btoa(encodeURIComponent(stringifiedMessageObject));
        window.sessionStorage.setItem('refInc', encodedMsg);
      }
    }
  };

  handleSendOTPSubmit(event, socialSignUpObj) {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ setInviteCodeError: true });
    // IF MOBILE NUMBER IS A MOBILE NUMBER
    let localErrorMsg = '';
    let isValidEmail = true;
    if (this.state.userEmailID !== '') {
      isValidEmail = validateEmail(this.state.userEmailID);
    }
    if (this.state.mobNum !== '' && validateMobile(this.state.mobNum) && isValidEmail) {
      localErrorMsg = '';
      this.props.accountCheck(
        { mobileNumber: this.state.mobNum, emailId: this.state.userEmailID },
        response => {
          let { success = false } = response;
          if (!response.hasOwnProperty('socialLogin') && !success) {
            // Not Registered Social user
            const yoloAuthDetails = sessionStorage.getItem('yolo_auth_details');
            if (yoloAuthDetails) {
              socialSignUpObj = {
                ...socialSignUpObj,
                ...JSON.parse(yoloAuthDetails)
              };
            }
            this.props.signupSendOTP(socialSignUpObj, ({ statusCode = '' }) => {
              if (parseInt(statusCode) == 1) {
                sessionStorage.removeItem('yolo_auth_details');
                this.setState({
                  showEnterOTP: true
                });
              }
            });
          } else {
            // Redirect To login
            const enableRestoreNumber = getEnableRestorePhoneNumber(this.props.flags);
            if (enableRestoreNumber) {
              gtmEventPush({
                page_name: 'social login - mobile screen',
                page_type: 'login/signup',
                event: 'user_account_interactions',
                category: 'user account interactions',
                action: 'formError',
                label:
                  'Mobile number is already linked to another account. Use a different mobile number'
              });
            }
            this.setState({ existingUser: true });
            createCookie('uI', this.state.mobNum);
          }
        }
      );
      if (this.state.inviteCode) {
        gtmEventPush({
          page_name: 'One Last Step',
          page_type: 'user account screen',
          event: 'user_account_interactions',
          category: 'user account interactions',
          action: 'One last step | Continue',
          label: `${socialSignUpObj.loginvia} - ${this.state.inviteCode}`,
          referral_code: this.state.inviteCode
        });
      } else {
        gtmEventPush({
          page_name: 'One Last Step',
          page_type: 'user account screen',
          event: 'user_account_interactions',
          category: 'user account interactions',
          action: 'One last step | Continue',
          label: `${socialSignUpObj.loginvia} - No code`,
          referral_code: 'No code'
        });
      }
    } else {
      localErrorMsg = 'Please enter a valid mobile number.';
      let typeError = '';
      if (localErrorMsg) {
        typeError = localErrorMsg;
      } else if (msg) {
        typeError = msg;
      }
      const enableRestoreNumber = getEnableRestorePhoneNumber(this.props.flags);
      if (enableRestoreNumber) {
        gtmEventPush({
          page_name: 'social login - mobile screen',
          page_type: 'login/signup',
          event: 'user_account_interactions',
          category: 'user account interactions',
          action: 'formError',
          label: typeError
        });
      } else {
        gtmEventPush({
          page_name: 'One Last Step',
          page_type: 'user account screen',
          event: 'formError',
          category: 'formError',
          action: 'One last step mobile form',
          label: typeError
        });
      }
    }
    this.setState({
      errorMsg: localErrorMsg
    });
    gtmEventPush({
      page_name: 'One Last Step',
      page_type: 'user account screen',
      event: 'user_account_interactions',
      category: 'user account interactions',
      action: 'continue'
    });
    // Segment Push Event
    segmentEventPush({
      screen_name: 'One Last Step',
      // page_type: 'user account screen',
      event: 'user_account_interactions',
      category: 'user account interactions',
      action: 'continue'
    });
  }

  handleOTPAuthSubmit(event, signUpAuthObj, viewSiteAs) {
    event.preventDefault();
    signUpAuthObj = { ...signUpAuthObj, requestType: requestType.AUTHUSER };
    signUpAuthObj = { ...signUpAuthObj, otp: this.state.otpEntered };
    this.props.signupAuthUser(signUpAuthObj, ({ refresh_token = '', statusCode = '' }) => {
      if (statusCode == 1) {
        var signInObj = {};
        signInObj = {
          username: signUpAuthObj.login,
          password: signUpAuthObj.password ? signUpAuthObj.password : signUpAuthObj.otp
        };
        const { location: { pathname = '' } = {}, queryString = '', isUaasOn } = this.props;
        if (this.state.otpEntered != '') {
          if (this.props.errorStatus == 400) {
            let { props: { errMsg = '' } = {} } = this;
            if (!errMsg) {
              errMsg = 'Please request a new OTP by clicking Resend OTP';
            }
            this.setState({
              errorMsg: errMsg,
              showTimer: false
            });
          } else if (refresh_token) {
            let socialSigninObject = {};
            if (isUaasOn) {
              socialSigninObject = {
                login: signUpAuthObj.login,
                token: signUpAuthObj.token,
                loginVia: signUpAuthObj.loginvia,
                profileId: signUpAuthObj.profileId
              };
            } else {
              socialSigninObject = {
                login: signUpAuthObj.login,
                token: signUpAuthObj.token,
                loginvia: signUpAuthObj.loginvia,
                profileId: signUpAuthObj.profileId
              };
            }
            this.props.socialAuth(socialSigninObject, authResponse => {
              if (authResponse?.refresh_token) {
                if (this.state.inviteCode) {
                  this.setReferralSuccessData();
                }
                const redirectURI = createRedirectUri(queryString);
                if (viewSiteAs == 'desktop') {
                  const loginStatus = signInCheck().length ? 'Login' : 'Not Login';
                  const { login_signup: { pageType = '' } = {} } = screen;
                  gtmEventPush({
                    event: 'register_success',
                    referral_page: window.location.href,
                    user_type: loginStatus,
                    login_method: 'OTP',
                    page_type: pageType,
                    page_name: 'login/signup screen'
                  });
                  // ga('send', {
                  //   eventCategory: 'Sign up',
                  //   eventAction: "Welcome to Ajio",
                  //   eventLabel: "Social Sign Up - Success"
                  // });
                  cleverTapPushEvent({
                    eventName: CLEVERTAP_EVENT_NAMES.User_Sign_Up,
                    eventObj: {
                      source: 'Sign Up Page',
                      type: 'Sign up Via Google',
                      user_id: this.state.mobNum,
                      platform: 'MSITE',
                      Gender: ''
                    }
                  });
                  if (pathname && pathname == '/login') {
                    window.location = redirectURI;
                  } else {
                    this.props.hideModal('sign-in-up');
                    let { location: { href = '' } = {} } = window;
                    if (!href.includes('/cart')) {
                      window.location.reload();
                    }
                  }
                } else {
                  if (this.state.inviteCode) {
                    gtmEventPush({
                      page_name: 'One Last Step',
                      page_type: 'user account screen',
                      event: 'user_account_interactions',
                      category: 'user account interactions',
                      action: 'Sign up suceess',
                      label: `${signUpAuthObj?.loginvia} - ${this.state.inviteCode}`,
                      referral_code: this.state.inviteCode
                    });
                  } else {
                    gtmEventPush({
                      page_name: 'One Last Step',
                      page_type: 'user account screen',
                      event: 'user_account_interactions',
                      category: 'user account interactions',
                      action: 'Sign up suceess',
                      label: `${signUpAuthObj?.loginvia} - No code`,
                      referral_code: 'No code'
                    });
                  }
                  ga('send', {
                    eventCategory: 'Sign up',
                    eventAction: 'Welcome to Ajio',
                    eventLabel: 'Social Sign Up - Success'
                  });
                  cleverTapPushEvent({
                    eventName: CLEVERTAP_EVENT_NAMES.User_Sign_Up,
                    eventObj: {
                      source: 'Sign Up Page',
                      type: 'Sign up Via Google',
                      user_id: this.state.mobNum,
                      platform: 'MSITE',
                      Gender: ''
                    }
                  });
                  window.location = redirectURI;
                }
              } else {
                this.setState({
                  errorMsg: 'Please enter a valid OTP',
                  showTimer: true
                });
              }
            });
          }
        }
      } else {
        this.setState({
          errorMsg: 'Please enter a valid OTP',
          showTimer: true
        });
      }
    });
  }

  getOTPforAuthCB = otpValue => {
    this.setState({ otpEntered: otpValue });
  };

  resendOTPforAuthCB = signUpObj => {
    this.handleSendOTPSubmit(event, signUpObj, this.props.viewSiteAs);
    this.setState({
      errorMsg: '',
      showTimer: true
    });
  };

  _renderComponent() {
    let { location: { search = '' } = {}, viewSiteAs = '', flags = {}, newDesignLuxe } = this.props;
    const { socialInfo } = this.state;

    let socialInfoObj;
    var obj = this.props.socialLoginInfo;
    socialInfoObj = obj || socialInfo;
    // console.log("[socialInfo]",socialInfo);
    let otpMsg = 'OTP will be sent to your number for verification.';
    let socialSignUpObj = {
      ...socialInfoObj,
      mobileNumber: this.state.mobNum,
      login: socialInfoObj.login === '' ? this.state.userEmailID : socialInfoObj.login,
      profileId: socialInfoObj.profileId
    };
    if (getReferralFeatureEnableFlag(flags) && getRefereeEnableFlag(flags)) {
      socialSignUpObj = { ...socialSignUpObj, rilFnlRegisterReferralCode: this.state.inviteCode };
    }
    let { existingUser = false } = this.state;
    // if (existingUser) {
    //   return (
    //     <OldPasswordComponent
    //       viewSiteAs={this.props.viewSiteAs}
    //       userCred={this.state.mobNum}
    //       queryString={search}
    //     />
    //   );
    // } else
    if (!this.state.showEnterOTP) {
      return (
        <div>
          <form
            className={`${newDesignLuxe ? 'luxe-newdesign' : ''} login-form`}
            onSubmit={e => this.handleSendOTPSubmit(e, socialSignUpObj)}
            data-ga-event-category=""
            data-ga-event-action=""
            data-ga-event-label=""
          >
            {this.renderReferralHeader()}
            {socialInfoObj.login === '' && (
              <div>
                <label>
                  Enter your email id
                  <input
                    type="text"
                    name="emailId"
                    id="emailId"
                    className="login-form-inputs"
                    placeholder=""
                    size="32"
                    maxLength="234"
                    value={this.state.userEmailID}
                    onChange={e => {
                      this.setState({
                        userEmailID: e.target.value
                      });
                    }}
                  />
                </label>
                {/* Display error message when mobileNumber is incorrect */}
                {this.state.errorMsg !== '' ? (
                  <div id="error-msg" className="error-msg" aria-live='polite'>
                    {this.state.errorMsg}
                  </div>
                ) : (
                  ''
                )}
              </div>
            )}
            <div>
              <label>
                Enter your mobile number
                <input
                  type="tel"
                  name="mobileNo"
                  id="mobileNo"
                  className="login-form-inputs"
                  placeholder=""
                  size="32"
                  maxLength="10"
                  value={this.state.mobNum}
                  onChange={e => {
                    this.setState({
                      mobNum: e.target.value
                    });
                  }}
                />
              </label>
              {/* Display error message when mobileNumber is incorrect */}
              {this.state.errorMsg !== '' ? (
                <div id="error-msg" className="error-msg" aria-live='polite'>
                  {this.state.errorMsg}
                </div>
              ) : existingUser ? (
                <div className="mob-already-exist">
                  Mobile number is already linked to another account. Use a different mobile number
                </div>
              ) : (
                <div className="mob-verify-otp">{otpMsg}</div>
              )}
            </div>
            {this.renderInviteCodeInput()}
            <div>
              <input type="submit" className="login-form-inputs login-btn" value="SEND OTP" />
            </div>
          </form>
        </div>
      );
    } else {
      return (
        <div>
          <form
            className={`${newDesignLuxe ? 'luxe-newdesign' : ''} signup-form`}
            onSubmit={e => this.handleOTPAuthSubmit(e, socialSignUpObj)}
            data-ga-event-category="Sign Up"
            data-ga-event-action="Welcome to AJIO"
            data-ga-event-label="Screen Launch"
          >
            <div>
              <h1>Sign In with OTP </h1>
              <h2 className="login-form-inputs user-cred-info">Please enter OTP sent to</h2>
              <div className="login-form-inputs masked-cred">{this.state.mobNum}</div>
              <OTPComponent
                getOTP={this.getOTPforAuthCB}
                resendOTP={() => this.resendOTPforAuthCB(socialSignUpObj)}
                viewSiteAs={viewSiteAs}
                showTimer={this.state.showTimer}
                errorMsg={this.state.errorMsg}
              />
              {/* newDesignLuxe = {newDesignLuxe} */}
              <div>
                <input
                  type="submit"
                  className="login-form-inputs login-btn"
                  value="START SHOPPING"
                />
              </div>
            </div>
          </form>
        </div>
      );
    }
  }

  render() {
    const newDesignLuxe = this.props.newDesignLuxe;
    console.log('signupsocial', newDesignLuxe);

    return this._renderComponent();
  }
}

const mapDispatchToProps = dispatch => {
  return {
    signupSendOTP: (formData, callback) => {
      dispatch(signupSendOTP(formData, callback));
    },
    signupAuthUser: (formData, callback) => {
      dispatch(signupAuthUser(formData, callback));
    },
    accountCheck: (formData, callback) => {
      dispatch(accountCheck(formData, callback));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    setReferrerDetailsObj: name => {
      dispatch(setReferrerDetails(name));
    },
    socialAuth: (params, cb) => {
      dispatch(socialAuth(params, cb));
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  const {
    signInReducer = {},
    signUpReducer = {},
    httpError = {},
    referAndEarn = {},
    flags = {}
  } = state;
  const { error = {} } = httpError;
  const { message = '' } = error;
  const { success = false, validUser = false } = signInReducer;
  const { authSuccess = 0 } = signUpReducer;
  const {
    referrerDetails = {},
    refereeIncentive = 0,
    refereeIncentiveExpiresIn = {}
  } = referAndEarn;

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);

  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const isUaasOn = getUaas(state);

  return {
    newDesignLuxe,
    accCheck: success,
    errStatus: signUpReducer.statusCode,
    authSuccess,
    errorStatus: error.statusCode,
    errMsg: message,
    refereeIncentive,
    referrerDetails,
    flags,
    refereeIncentiveExpiresIn,
    isUaasOn
  };
};

export default SignUpSocial = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SignUpSocial)
);
